export interface MealWithDates {
  meal_time?: string | null;
  created_at?: string | null;
}

/** Canonical meal occurrence time — prefer meal_time (editable "when eaten"). */
export function getEffectiveMealTimestamp(meal: MealWithDates): Date | null {
  const src = meal.meal_time || meal.created_at;
  if (!src) return null;
  const d = new Date(src);
  if (isNaN(d.getTime()) || d.getFullYear() <= 1971) return null;
  return d;
}

export function toLocalDateKey(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function getMealLocalDateKey(meal: MealWithDates): string | null {
  const d = getEffectiveMealTimestamp(meal);
  return d ? toLocalDateKey(d) : null;
}

export function buildSyncedMealTimestamps(value: string | Date): {
  meal_time: string;
  created_at: string;
} {
  const iso = new Date(value).toISOString();
  return { meal_time: iso, created_at: iso };
}
